import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { throttle } from 'lodash';
import styled from 'styled-components';

const Container = styled.div`
  position: relative;
`;

class ScrolledWrapper extends PureComponent {
  constructor() {
    super();
    this.state = {
      isScrolledToBottom: false,
    };
  }

  componentDidMount() {
    document.addEventListener('scroll', this.onScroll);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.onScroll);
  }

  onScroll = throttle(() => {
    const el = document.scrollingElement;
    const article = document.querySelector('#articleContent');

    if (article) {
      if (!this.state.isScrolledToBottom) {
        const articleBottomLine = article.offsetHeight + article.offsetTop;
        const distanceScrolled = window.innerHeight + el.scrollTop;
        if (distanceScrolled > articleBottomLine) {
          this.setState({ isScrolledToBottom: true });
          if (typeof document !== 'undefined' && window.analytics) {
            analytics.track('Magazine article scrolled to bottom');
          }
        }
      }
    }
  }, 300);

  render() {
    return <Container>{this.props.children}</Container>;
  }
}

ScrolledWrapper.propTypes = {
  children: PropTypes.node,
};

export default ScrolledWrapper;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/article/ScrolledWrapper.js